module.exports = __webpack_public_path__ + "static/media/SS.342ec5f6.png";